import React, { Component } from 'react';
import { Gym, GymTypes } from 'fitbeat.models';
import { View, Platform, StyleSheet } from 'react-native';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { moderateScale } from 'react-native-size-matters';
import { GymLocation } from './GymLocation';
import { setSelectedGym as setSelectedGymAction } from '../actions';
import BookingLocationIcon from './BookingLocationIcon';
import Theme from '../../theme';
import { styles as componentStyles } from './Styles';
import { GymLocationSelection } from './GymLocationSelection';
import { defaultScale } from '../../utils/scaling';
import { currentSelectedGymSelector, isOfficeScheduleBookingSelector } from '../selectors';
import { enabledFeaturesSelector } from '../../auth';

const isMobileWeb = Platform.OS === 'web' && window.innerWidth <= 550;

interface IProps {
  currentSelected: Gym;
  isOfficeScheduleBooking: boolean;
  homeGym: Gym;
  studioGyms: Gym[];
  setSelectedGym: (gymName: string, atStudio: boolean) => void;
}

class GymDropdown extends Component<IProps> {
  public changeSelectedGym = (gymName: string, atStudio: boolean) => {
    const { setSelectedGym } = this.props;
    setSelectedGym(gymName, atStudio);
  };

  public render() {
    const {
      currentSelected, isOfficeScheduleBooking, studioGyms, homeGym,
    } = this.props;
    const hasMultipleGymLocations = [homeGym, ...studioGyms].length > 1;

    if (!hasMultipleGymLocations) {
      return (
        <GymLocationSelection
          homeGym={homeGym}
          currentGym={currentSelected}
          defaultStudioGym={studioGyms[0]}
          onPress={this.changeSelectedGym}
          studioGymLocation={studioGyms[0]?.displayName}
          isOfficeScheduleBooking={isOfficeScheduleBooking}
        />
      );
    }

    const menuListStyle = isMobileWeb ? {
      width: '92vw',
      right: 0,
    } : { left: 0 };

    const isStudioGymSelected = currentSelected
      && (currentSelected.type === GymTypes.Indoor || isOfficeScheduleBooking);
    const studioGymLocation = isStudioGymSelected
      ? currentSelected.displayName
      : studioGyms[0].displayName;
    return (
      <View style={componentStyles.gymDropdownContainer}>
        <GymLocationSelection
          homeGym={homeGym}
          currentGym={currentSelected}
          defaultStudioGym={studioGyms[0]}
          onPress={this.changeSelectedGym}
          studioGymLocation={studioGymLocation}
          isOfficeScheduleBooking={isOfficeScheduleBooking}
        />
        {isStudioGymSelected && studioGyms.length > 1
                    && (
                    <View style={componentStyles.dropdownContainer}>
                      <BookingLocationIcon />
                      <GymLocation
                        onSelect={(gymName) => this.changeSelectedGym(gymName, true)}
                        gymLocationList={studioGyms}
                        defaultGym={currentSelected.displayName}
                        useTransparentTheme
                        useFullScreenWidth
                        mainDropdownContainerStyle={{ flex: 1, marginVertical: defaultScale(2) }}
                        controlStyle={{ height: defaultScale(23), paddingLeft: defaultScale(3) }}
                        controlTextStyle={{
                          ...Theme.textStyle.bodyCopyReg,
                          color: Theme.CHARCOAL,
                        }}
                        optionsStyle={{ marginTop: defaultScale(10) }}
                        iconSize={defaultScale(20)}
                        menuListStyle={menuListStyle}
                        adjustFrameOptions={{ left: defaultScale(15) }}
                      />
                    </View>
                    )}
      </View>
    );
  }
}

export const styles = StyleSheet.create({
  gymTypeSelectionContainer: {
    paddingVertical: defaultScale(10),
    flexDirection: 'row',
  },
  radioButtonContainer: {
    flex: 1,
  },
  radioButtonTextStyle: {
    fontSize: moderateScale(14, 2),
    fontFamily: Theme.Custom500,
    color: Theme.CHARCOAL,
  },
});

const mapStateToProps = (state) => {
  const enabledFeatures = enabledFeaturesSelector(state);

  return {
    currentSelected: currentSelectedGymSelector(state),
    isOfficeScheduleBooking: isOfficeScheduleBookingSelector(state),
    studioGyms: enabledFeatures.workout.allowedStudioGyms,
    homeGym: enabledFeatures.workout.homeGym,
  };
};

const mapDispatchToProps = (dispatch) => ({
  setSelectedGym: (currentSelectedGymName, atStudio) => dispatch(
    setSelectedGymAction(currentSelectedGymName, atStudio),
  ),
});

const GymDropdownConnected = connect(mapStateToProps, mapDispatchToProps)(GymDropdown);
export default translate(['bookings'], { wait: true })(GymDropdownConnected);
